import React, { useRef, useContext, useEffect, useState } from "react";

import {
  GridColumns,
  DataGrid,
  GridActionsCellItem,
  GridRowParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  Modal,
  IconButton,
  CardContent,
  Paper,
  Skeleton,
  useMediaQuery,
  Theme,
} from "@mui/material";
import {
  AddTwoTone,
  PictureAsPdfTwoTone,
  PrintTwoTone,
  AccountCircleTwoTone,
  SmartphoneTwoTone,
  PinDropTwoTone,
  DeleteTwoTone,
  EditTwoTone,
  HighlightOffTwoTone,
} from "@mui/icons-material";

import MailTwoToneIcon from "@mui/icons-material/MailTwoTone";

import { pdf, PDFViewer } from "@react-pdf/renderer";
import moment from "moment";
import useAxios from "axios-hooks";

import {
  OrderIdSectionSkeleton,
  UserDetailsSkeleton,
  OrderDeliveryDetailsSkeleton,
  TableSkeleton,
  TableBoxHeaderSkeleton,
  CalculationSectionSkeleton,
  OrderTimelineSkeleton,
  MapSectionSkeleton,
} from "components/skeleton/orderDetailSkeleton";
import Tooltip from "components/tooltip";
import Notify from "components/notify";
import MainCard from "components/mainCard";
import Button from "components/button";
import GoogleMapFrame from "components/googleMapFrame";
import TextField from "components/textField";
import Progress from "components/progress";
import RadioButton from "components/radioButton";

import { OrderDetailColumns, printerOptions } from "utils/constants";
import PackingSlip from "../packingSlip";
import ExcelExport from "features/components/excelExport";
import { OptionSetContext } from "features/components/optionSetContext";
import {
  convertFromGrams,
  convertToGrams,
  formatDateTimeString,
  getSubscription,
} from "features/components/helperFunctions";
import OrderStatusAction from "../orderStatusAction";
import AddEditItem from "../addEditItem";
import ThermalReceiptPrint, { handlePrint } from "../thermalReceiptPrint";
import { useSelector } from "store";
import {
  OrderListingResponseResult,
  BizDeliveryPayloadType,
  OrderDeliveryAreasRequest,
  CanadaPostSettingsResult,
  OrderListingResponseOrderDetail,
  ProductResponseItem,
} from "utils/types";
import { OrderDetailsProps } from "../index.types";
import { API_END_POINTS } from "utils/constants/APIEndPoints";
import {
  capitalizeFirstLetter,
  validateCouponCode,
} from "utils/helperFunctions";
import {
  actionModalSX,
  mainCardSX,
  mapFrameCardSXStyles,
  mapFrameContentStyles,
  orderDetailsHeading,
  productItemsTableStyle,
  responsiveAlignmentEnd,
  subscriptionTypeStyles,
  responsiveAlignmentStart,
  textAreaStyles,
  orderDetailHeaderParent,
  orderIdGridStyles,
  orderIdStackStyles,
  headerOrderInfoStack,
  modalButtonStyles,
  orderPrintStack,
  orderPrinterButton,
} from "../index.styles";
import { logDataChange } from "services/fireStore";

export const useStyles = makeStyles(() => ({
  excelExportFile: {
    width: "104px",
    height: " 20px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  downloadPdf: {
    width: "92px",
    height: "20px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  pdf_print_user_phone_location_IconColor: {
    color: "#616161",
  },
  printHeading: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  tableItemNoColumn: {
    paddingLeft: "unset !important",
    paddingRight: "30px !important",
  },
}));

let errorMessage = { address: "", mobileNo: "", deliveryCharges: "" };

let discountOnFly = false;
let makeCartItemsUnique = 0;

const OrderDetail = ({
  failedPayment,
  setOrderDetailModal,
  orderDetailModal,
  selectedOrder,
}: OrderDetailsProps) => {
  const { eatout_id, user_id } = JSON.parse(
    localStorage.getItem("businessInfo")!
  );
  const classes = useStyles();
  const {
    loaders,
    setOptions,
    setEditAbleItem,
    preventOrderUpdate,
    setPreventOrderUpdate,
    selectedOrderContext,
    setSelectedOrderContext,
    cancelUpdateButtonToggle,
    setCancelUpdateButtonToggle,
  } = useContext(OptionSetContext);
  const { decimalPlaces, minimumSpend, currency, startDate, endDate } =
    useSelector((state) => state.global);
  const [fieldError, setFieldError] = useState(errorMessage);
  const [orderDetailLoader, setOrderDetailLoader] = useState(false);
  const [customerDetailLoader, setCustomerDetailLoader] = useState(false);
  const [rowSkeletonLoader, setRowSkeletonLoader] = useState(false);

  const [orderFromAPI, setOrderFromAPI] = useState<
    OrderListingResponseResult[]
  >([]);
  const [openAddEditItemModal, setAddEditItemModal] = useState<boolean>(false);
  const [packingSlip, setPackingSlip] = React.useState(false);
  const [editItemFlag, setEditItemFlag] = useState<boolean>(false);
  const [customerDetailModal, setCustomerDetailModal] = useState(false);
  const [notify, setNotify] = useState<boolean>(false);
  const [notifyMessage, setNotifyMessage] = useState("");
  const [notifyType, setNotifyType] = useState<
    "success" | "info" | "warning" | "error"
  >("info");
  const [deliveryChargesModal, setDeliveryChargesModal] = useState(false);

  const [customerAddress, setCustomerAddress] = React.useState("");
  const [customerMobileNo, setCustomerMobileNo] = React.useState("");
  const [pickupModal, setPickupModal] = useState(false);
  const [pickuptime, setPickupTime] = useState("");
  const [pickupComment, setPickupComment] = useState("");
  const [staffNote, setStaffNote] = useState("");

  // Weight States
  const [totalWeight, setTotalWeight] = useState(0);
  const [weightUnit, setWeightUnit] = useState("");

  // Delivery States
  const [deliveryChargesList, setDeliveryChargesList] = useState([
    {
      label: "",
      value: "",
    },
  ]);
  const [canadaPostDeliveryCharges, setCanadaPostDeliveryCharges] =
    useState("");
  const [deliveryChargeField, setDeliveryChargesField] = useState("");

  const [toggleDiscount, setToggleDiscount] = useState(false);
  const [discountField, setDiscountField] = useState("0");

  const [togglePrinterModal, setTogglePrinterModal] = useState<boolean>(false);

  // Add this with other state declarations
  const selectedPrinterRef = useRef<string>("standard");

  const isScreenSmall = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const { branchesAccessDetails } = useSelector(
    (state) => state.businessBranches
  );
  const { businessAllBranches } = useSelector(
    (state) => state.businessBranches
  );
  const { selectedBranch } = useSelector((reduxState) => reduxState.dropdown);

  //======================================= Payloads =======================================//

  const pickupChangePayload = () => {
    const time = moment(pickuptime).format("YYYY-MM-DD HH:mm:ss");
    const formData = new FormData();

    formData.append("pickup_time", time); // 2023-05-09 03:15:00
    formData.append("comment", pickupComment);
    formData.append("eatout_id", eatout_id);
    formData.append("order_id", `${selectedOrder.order_id}`);
    formData.append("email", selectedOrder.user_email);
    formData.append("admin_id", user_id);
    formData.append("source", "biz");
    return formData;
  };

  // single order API call payload
  const getSingleOrderAPIPayload = () => {
    const formData = new FormData();
    formData.append("from_date", `${startDate}`);
    formData.append("to_date", `${endDate}`);
    formData.append("eatout_id", eatout_id);
    formData.append("order_id", `${selectedOrder.order_id}`);
    formData.append("bid", `${selectedOrder.branch_id}`);
    formData.append("user_email", selectedOrder.user_email);
    formData.append("bid", `${selectedOrder.branch_id}`);
    formData.append("payment_type", failedPayment ? "1" : "0");
    formData.append("attributes", `${1}`);
    formData.append("admin_id", user_id);
    formData.append("source", "biz");
    return formData;
  };

  // customer info update API call payload
  const customerInfoUpdateAPIPayload = () => {
    const { order_id } = orderFromAPI[0];

    const formData = new FormData();
    formData.append("eatout_id", eatout_id);
    formData.append("order_id", order_id);
    formData.append("mobile", customerMobileNo);
    formData.append("address", customerAddress);
    formData.append("landline", staffNote);
    formData.append("admin_id", user_id);
    formData.append("source", "biz");
    return formData;
  };
  // Delivery charges
  const orderDeliveryChargesAPIPayload = (item: OrderDeliveryAreasRequest) => {
    const formData = new FormData();

    formData.append("eatout_id", `${eatout_id}`);
    formData.append("lat", `${item["lat"]}`);
    formData.append("lng", `${item["lng"]}`);
    formData.append("bid", `${item["bid"]}`);
    formData.append("weight", `${item["weight"]}`);
    formData.append("postal_code", `${item["postal_code"]}`);
    formData.append("admin_id", user_id);
    formData.append("source", "biz");
    return formData;
  };

  // biz-Delivery-Calculation API call payload
  const bizDeliveryCalculationAPIPayload = (
    bizDeliveryPayload: BizDeliveryPayloadType
  ) => {
    const formData = new FormData();

    formData.append("source", "biz");
    formData.append("eatout_id", eatout_id);
    formData.append("admin_id", user_id);
    formData.append("param", JSON.stringify(bizDeliveryPayload));
    return formData;
  };

  // order update API call payload
  const orderUpdateAPIPayload = (orderUpdate_payload: any) => {
    const formData = new FormData();

    formData.append("orders", JSON.stringify(orderUpdate_payload));
    formData.append("admin_id", user_id);
    formData.append("source", "biz");
    return formData;
  };
  //======================================= API Calls & Payloads =======================================//
  // single order API call
  const [{}, getSingleOrderAPICall] = useAxios(
    {
      url: "/order_get",
      method: "post",
    },
    { manual: true }
  );

  // order_pickup_change
  const [
    { loading: pickupLoading, error: pickupError },
    orderPickupChangeAPICall,
  ] = useAxios(
    {
      ...API_END_POINTS.orderPickupChange,
      data: pickupChangePayload(),
    },
    { manual: true }
  );

  // order update API call
  const [{}, orderUpdateAPICall] = useAxios(
    {
      url: "/order_update",
      method: "post",
    },
    { manual: true }
  );

  // biz-Delivery-Calculation API call
  const [{}, bizDeliveryCalculationAPICall] = useAxios(
    {
      url: `${process.env.REACT_APP_TOSSDOWN_SITE}/delivery_calculations`,
      method: "post",
    },
    { manual: true }
  );

  // customer info update API call
  const [{}, customerInfoUpdateAPICall] = useAxios(
    {
      url: "/update_user_order_info",
      method: "post",
    },
    { manual: true }
  );

  // get single item API call (for edit item)
  const [{}, singleItemCall] = useAxios({ method: "get" }, { manual: true });

  const [{ data: canadaPostSetting }, orderDeliveryChargesAPICall] = useAxios(
    {
      url: "/get_order_delivery_areas",
      method: "post",
      data: orderDeliveryChargesAPIPayload({
        eatout_id,
        lat: selectedOrderContext.user_latitude,
        lng: selectedOrderContext.user_longitude,
        bid: selectedOrderContext.eatout_bid,
        weight: totalWeight,
        postal_code: selectedOrderContext.postal_code,
        admin_id: user_id,
        source: "biz",
      }),
    },
    { manual: true }
  );
  //======================================= useEffect Hooks =======================================//

  useEffect(() => {
    // set order detail response to state
    (async () => {
      setOrderDetailLoader(true);

      // API call to get single order
      const {
        data: { result },
      } = await getSingleOrderAPICall({
        data: getSingleOrderAPIPayload(),
      });

      if (result.length > 0) {
        setSelectedOrderContext(result[0]);
        setOrderFromAPI(result);

        // give delivery charges to delivery charges state
        setDeliveryChargesField(result[0].delivery_charges);
        setDiscountField(result[0].discount_value);
        if (result[0].order_type_flag === "1") {
          setPickupTime(result[0].pickup_time);
        }
        // update weights
        weightUpdate(result[0]);
        setCustomerMobileNo(result[0]?.mobile_number);
        setCustomerAddress(result[0]?.address);
        setStaffNote(result[0]?.landline_number);
      }

      setOrderDetailLoader(false);
    })();
  }, []);

  useEffect(() => {
    if (orderFromAPI[0]) {
      // update delivery Charges
      updateDeliveryCharges();
    }
  }, [orderFromAPI[0]]);

  useEffect(() => {
    if (!canadaPostSetting) return;

    if (
      canadaPostSetting.canada_post_settings &&
      canadaPostSetting.canada_post_settings.status === "200"
    ) {
      const { result } = canadaPostSetting.canada_post_settings;
      const canadaPostOptions =
        result &&
        result.map((option: CanadaPostSettingsResult) => ({
          label: `${option.name} (${option.price} CAD)`,
          value: option.price,
        }));
      setDeliveryChargesList(canadaPostOptions);

      setCustomerDetailLoader(false);
    }
  }, [canadaPostSetting]);

  //======================================= Helper Functions =======================================//

  const openDeliveryModal = () => {
    setDeliveryChargesModal(true);

    if (Number(selectedOrderContext.canada_post)) {
      const { user_latitude, user_longitude, eatout_bid, postal_code } =
        selectedOrderContext;

      setCustomerDetailLoader(true);

      orderDeliveryChargesAPICall({
        data: orderDeliveryChargesAPIPayload({
          eatout_id,
          lat: user_latitude,
          lng: user_longitude,
          bid: eatout_bid,
          weight: totalWeight,
          postal_code: postal_code,
          admin_id: user_id,
          source: "biz",
        }),
      });
    }
  };
  const toggleDiscountModal = () =>
    setToggleDiscount((prevState) => !prevState);

  // Delivery charges handler
  const handleDeliveryChargesField = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setFieldError({ ...fieldError, deliveryCharges: "" });
    setDeliveryChargesField(e.target.value);
  };

  // Update Delivery Charges
  const handleDeliveryChargesUpdate = () => {
    discountOnFly = false;
    const customDeliveryCharges = "1";
    if (selectedOrderContext.canada_post === "1") {
      if (canadaPostDeliveryCharges === "") return;

      setDeliveryChargesField(canadaPostDeliveryCharges);

      // update Order
      makeOrderDetailObjForBizDeliveryAPI("", customDeliveryCharges);
      setDeliveryChargesModal(false);
    } else if (deliveryChargesValidation()) {
      makeOrderDetailObjForBizDeliveryAPI("", customDeliveryCharges);
      setDeliveryChargesModal(false);
    }
  };

  const deliveryChargesValidation = () => {
    if (!deliveryChargeField) {
      setFieldError({
        ...fieldError,
        deliveryCharges: "Please Enter the Delivery Charges",
      });

      return false;
      // entry should be positive integer or float
    } else if (!/^[0-9.|()&^]*$/.test(deliveryChargeField)) {
      setFieldError({
        ...fieldError,
        deliveryCharges: "Please Enter a Positive number",
      });

      return false;
    }
    return true;
  };

  const toggleCustomerDetailModal = () => {
    if (!customerDetailModal) {
      setCustomerAddress(orderFromAPI[0].address);
      setCustomerMobileNo(orderFromAPI[0].mobile_number);
    }

    setCustomerDetailModal((state) => !state);
  };

  const togglePickupModal = () => setPickupModal((state) => !state);

  const handleAddressChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setFieldError({ ...fieldError, address: "" });
    setCustomerAddress(e.target.value);
  };

  const handleMobileNoChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setFieldError({ ...fieldError, mobileNo: "" });
    setCustomerMobileNo(e.target.value);
  };

  const canadaPostHandler = (e: { target: { value: string } }) => {
    setCanadaPostDeliveryCharges(e.target.value);
  };

  const closeCustomerDetailsModel = () => {
    setCustomerDetailLoader(false);
    setCustomerDetailModal(false);

    setNotifyMessage("Customer details updated successfully");
    setNotifyType("success");
    setNotify(true);
  };

  const handleCustomerDetailUpdate = async (
    event: any,
    pass: boolean = true
  ) => {
    if (customerAddress === "" && pass) {
      setFieldError({ ...fieldError, address: "Enter your address!" });
      return;
    } else if (customerMobileNo === "" && pass) {
      setFieldError({ ...fieldError, mobileNo: "Enter your mobile no!" });
      return;
    } else {
      setCustomerDetailLoader(true);

      // customer info update API call
      const {
        data: { status },
      } = await customerInfoUpdateAPICall({
        data: customerInfoUpdateAPIPayload(),
      });

      if (status === "1") {
        let selectedOrder = [...orderFromAPI];

        selectedOrder[0].mobile_number = customerMobileNo;
        selectedOrder[0].address = customerAddress;
        selectedOrder[0].landline_number = staffNote;

        setOrderFromAPI(selectedOrder);

        closeCustomerDetailsModel();
      }
    }
  };

  const closeNotify = () => setNotify(false);

  const linearLoader = () => {
    return <Progress type="linear" />;
  };

  const getEditItemCallback = (editedItem: OrderListingResponseOrderDetail) => {
    discountOnFly = false;
    let selectedOrder = orderFromAPI;

    const editedOrderDetail = selectedOrder[0].order_detail.map((item) =>
      item.order_detail_id === editedItem.order_detail_id ? editedItem : item
    );

    selectedOrder[0].order_detail = editedOrderDetail;
    setOrderFromAPI(selectedOrder);

    // make payload object for biz-delivery-calculation api
    makeOrderDetailObjForBizDeliveryAPI("editItem");
  };

  const updateDeliveryCharges = () => {
    orderFromAPI[0].canada_post == "1"
      ? setCanadaPostDeliveryCharges(orderFromAPI[0].delivery_charges)
      : setDeliveryChargesField(orderFromAPI[0].delivery_charges);
  };

  // getting new item in order
  const getNewItemCallback = (item: ProductResponseItem) => {
    discountOnFly = false;
    if (checkItemExistence(item)) {
      setNotifyMessage(
        "Item already exists in the list, Please update the item"
      );
      setNotifyType("error");
      setNotify(true);
      return;
    } else {
      // creating object To Append In Order Detail array for table
      let objectToAppendInOrderDetail = { ...orderFromAPI[0].order_detail[0] };

      objectToAppendInOrderDetail.attributes = item.attributes;
      objectToAppendInOrderDetail.item_name = item.name;
      objectToAppendInOrderDetail.brand_name = item.item_brand[0].brand_name;
      objectToAppendInOrderDetail.item_id = item.menu_item_id;
      objectToAppendInOrderDetail.product_code = item.product_code;
      objectToAppendInOrderDetail.item_cat_id = item.menu_cat_id;

      objectToAppendInOrderDetail.quantity = item.quantity;
      objectToAppendInOrderDetail.price = item.price;
      objectToAppendInOrderDetail.status = item.status;
      objectToAppendInOrderDetail.weight_value = item.weight_value;
      objectToAppendInOrderDetail.weight_unit = item.weight_unit;
      objectToAppendInOrderDetail.comment = item.comment;
      objectToAppendInOrderDetail.discount = item.discount;
      objectToAppendInOrderDetail.tax = item.tax
        ? item.tax
        : orderFromAPI[0].tax;
      objectToAppendInOrderDetail.options = item.options;
      objectToAppendInOrderDetail.brand_id = item.item_brand[0].brand_id;
      objectToAppendInOrderDetail.label = item.label;
      objectToAppendInOrderDetail.order_detail_id =
        item.menu_item_id + makeCartItemsUnique++;

      // handling pre-auth for biz delivery calculations
      if (orderFromAPI[0].pre_auth == "1") {
        if (typeof item.calculated_weight === "undefined")
          objectToAppendInOrderDetail.weight = item.weight_value
            ? Number(item.weight_value)
            : 0.5;
        else
          objectToAppendInOrderDetail.weight =
            item.calculated_weight > 0 ? Number(item.calculated_weight) : 0.5;
      } else {
        objectToAppendInOrderDetail.weight = Number(item.weight_value);
      }

      // these keys are not present in some items
      objectToAppendInOrderDetail.total = "";
      objectToAppendInOrderDetail.item_level_grand_total = "";
      objectToAppendInOrderDetail.category_id = item.menu_cat_id;
      objectToAppendInOrderDetail.item_level_discount_value = "";
      objectToAppendInOrderDetail.coupon_discount = "";
      objectToAppendInOrderDetail.coupon_discount_value = "";
      objectToAppendInOrderDetail.item_level_tax_value = "";

      let selectedOrders = orderFromAPI;

      selectedOrders[0].order_detail = [
        ...orderFromAPI[0].order_detail,
        objectToAppendInOrderDetail,
      ];

      setOrderFromAPI(selectedOrders);

      // make payload object for biz-delivery-calculation api
      makeOrderDetailObjForBizDeliveryAPI("addItem");
    }
  };

  function checkOptionSetEquality(
    obj1String: string,
    obj2String: string
  ): boolean {
    try {
      const obj1: any = JSON.parse(obj1String);
      const obj2: any = JSON.parse(obj2String);

      const keys1 = Object.keys(obj1);

      for (const key of keys1) {
        if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
          const array1 = obj1[key];
          const array2 = obj2[key];

          if (
            !Array.isArray(array1) ||
            !Array.isArray(array2) ||
            array1.length !== array2.length
          ) {
            return false;
          }

          for (let i = 0; i < array1.length; i++) {
            if (array1[i].name !== array2[i].name) {
              return false;
            }
          }
        } else {
          return false; // Keys are not equal
        }
      }

      return true;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return true;
    }
  }

  const checkItemExistence = (newItem: ProductResponseItem) => {
    return orderFromAPI[0].order_detail.some((orderItem) => {
      if (orderItem.item_id === newItem.menu_item_id) {
        if (newItem.options) {
          let options;
          try {
            options = JSON.parse(newItem.options);
          } catch (error) {
            console.error("Error parsing options JSON:", error);
            return true;
          }

          if (options?.length) {
            return checkOptionSetEquality(orderItem.options, newItem.options);
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
  };

  const makeOrderDetailObjForBizDeliveryAPI = async (
    actionType: string,
    customDeliveryCharges = "0"
  ) => {
    if (actionType === "addItem") {
      setRowSkeletonLoader(true);
    } else {
      // linear loader in case of edit and delete
      setOrderDetailLoader(true);
    }

    const selectedOrderDetail = orderFromAPI[0].order_detail;
    let selectedOrder = { ...orderFromAPI[0] };

    let updateSubTotal = 0;
    /*
      Sum subtotal on order edit
      discountOnFly = false
      - Add item
      - edit item
      - delete item
      - delivery Charges update

      discountOnFly = true
      - discount edit
      Add updated subtotal and calculate it's item level discount percentage
     */
    let discountPercentage = 0;

    if (discountOnFly) {
      selectedOrderDetail.forEach((itemDetail) => {
        let itemSubTotal = 0;

        itemSubTotal = Number(itemDetail.price) * Number(itemDetail.quantity);

        updateSubTotal = updateSubTotal + itemSubTotal;
        itemDetail.total = itemSubTotal.toString();
      });

      discountPercentage = (Number(discountField) * 100) / updateSubTotal;
    }

    const getDiscountValue = (itemDiscount: number | string) => {
      return itemDiscount === ""
        ? selectedOrder.discount
        : Number(itemDiscount) > 0
        ? itemDiscount
        : "0";
    };

    // array of objects like; this is created for biz_delivery_calculation
    const orderDetailItemsArrayForBizDelivery = selectedOrderDetail.map(
      (item) => ({
        menu_item_id: item.item_id,
        productname: item.item_name,
        label: item.label,
        productprice: item.price,
        itemQty: item.quantity,
        item_total: item.total,
        rid: eatout_id,
        item_category_id: item.category_id,
        item_brand_id: item.brand_id,
        product_code: item.product_code,
        weight_value: item.weight_value,
        weight_unit: item.weight_unit,
        note: item.comment,
        newItemTax: item.tax,
        newItemDiscount: discountOnFly
          ? (Number(item.total) * discountPercentage) / 100
          : getDiscountValue(item.item_level_discount_value),
        newItemDiscountPer: discountOnFly
          ? discountPercentage
          : item.discount
          ? item.discount
          : "0",
        slug: `menu_item_id_${item.item_id}`,
        option: item.options,
      })
    );

    selectedOrder.total = updateSubTotal.toString();

    let bizDeliveryPayload = {
      session: {},
      user_email: "",
      order_type: "",
      custom_code_type: "",
      coupon_apply_bit: "",
      coupon_discount: "",
      coupon_id: "",
      res_id: "",
      tip: "",
      delivery_charges: "",
      service_charges: "",
      usr_lat: "",
      usr_lng: "",
      delivery_bit: "",
      branch_id: "",
      postal_code: "",
      canada_post: "",
      custom_delivery_charges: "",
      custom_code: "",
      tax: "",
      tax_value: "",
      discount: "",
      discount_value: "",
      total_amount: "",
    };

    const formatOptionSet = (item: any) => {
      let option: any = {};
      if (
        item.option &&
        item.option !== "{}" &&
        Object.keys(item.option).length !== 0
      ) {
        let obj: any = {};
        const options = JSON.parse(item.option);
        for (const key in options) {
          const option_array: any = [];
          options[key].map((option: any) => {
            option_array.push(
              `${option.name},${option.price},${option.quantity}`
            );
            if (option.inner_options && option.inner_options !== "{}") {
              let innerObj: any = {};
              for (const innerKey in option.inner_options) {
                option.inner_options[innerKey].map((innerOption: any) => {
                  innerObj[
                    innerKey
                  ] = `${innerOption.name},${innerOption.price},${innerOption.quantity}`;
                });
              }
              option_array.push({ ...innerObj });
            }
          });
          obj[key] = [...option_array];
          option = obj;
        }
        return option;
      } else return "";
    };

    // type is any because we are getting the unknown keys according to item id
    let itemsSessionObj: any = {};

    if (orderDetailItemsArrayForBizDelivery.length > 0) {
      orderDetailItemsArrayForBizDelivery.forEach((item) => {
        // Making menu menuItemIdOptionNameSlug
        let optionSetName = "";
        if (item.option) {
          const itemOptions = JSON.parse(item.option);
          for (const option in itemOptions) {
            itemOptions[option].map((optionItem: any) => {
              if (optionSetName === "")
                optionSetName = `${optionItem.name
                  .split(" ")
                  .join("")
                  .toLowerCase()}`;
              else
                optionSetName = `${optionItem.name
                  .split(" ")
                  .join("")
                  .toLowerCase()}`;
            });
          }
        }
        item.option = formatOptionSet(item);
        let makeAKey = `${item.slug}${optionSetName}`;

        // make session object with menuItemIdOptionNameSlug keys with their respective values
        itemsSessionObj[makeAKey] = item;
      });
    }

    bizDeliveryPayload.session = JSON.stringify(itemsSessionObj);
    bizDeliveryPayload.user_email = orderFromAPI[0].user_email;
    bizDeliveryPayload.order_type = orderFromAPI[0].order_type;
    bizDeliveryPayload.coupon_discount = orderFromAPI[0].custom_code_discount;

    bizDeliveryPayload.coupon_apply_bit =
      Number(orderFromAPI[0].custom_code_discount) > 0 ? "1" : "0";

    bizDeliveryPayload.custom_code_type = orderFromAPI[0].custom_code_type;
    bizDeliveryPayload.coupon_id = orderFromAPI[0].custom_code_id;
    bizDeliveryPayload.res_id = eatout_id;
    bizDeliveryPayload.tip = orderFromAPI[0].tip;
    /*
      Give latest delivery charges to API
     */

    bizDeliveryPayload.delivery_charges =
      orderFromAPI[0].canada_post == "1"
        ? canadaPostDeliveryCharges
        : deliveryChargeField;
    bizDeliveryPayload.service_charges = orderFromAPI[0].service_charges;
    bizDeliveryPayload.usr_lat = orderFromAPI[0].user_latitude;
    bizDeliveryPayload.usr_lng = orderFromAPI[0].user_longitude;
    bizDeliveryPayload.delivery_bit = orderFromAPI[0].pre_auth;
    bizDeliveryPayload.branch_id = orderFromAPI[0].eatout_bid;
    bizDeliveryPayload.custom_delivery_charges = customDeliveryCharges;
    bizDeliveryPayload.postal_code = orderFromAPI[0].postal_code;
    bizDeliveryPayload.canada_post = orderFromAPI[0].canada_post;
    bizDeliveryPayload.custom_code = orderFromAPI[0].custom_code;

    bizDeliveryPayload.tax = orderFromAPI[0].tax;
    bizDeliveryPayload.tax_value = orderFromAPI[0].tax_value;
    bizDeliveryPayload.discount = orderFromAPI[0].discount;
    bizDeliveryPayload.discount_value = "0";
    bizDeliveryPayload.total_amount = selectedOrder.total;

    // biz-Delivery-Calculation API call
    const {
      data: { final_order_array },
    } = await bizDeliveryCalculationAPICall({
      data: bizDeliveryCalculationAPIPayload(bizDeliveryPayload),
    });

    if (final_order_array) {
      let selectedOrder = orderFromAPI;
      const itemsFromBizDelivery = final_order_array.items;

      selectedOrder[0].total = final_order_array.sub_total;
      selectedOrder[0].grand_total = final_order_array.grand_total;
      selectedOrder[0].tax_value = final_order_array.tax;
      selectedOrder[0].discount_value = final_order_array.discount;
      selectedOrder[0].custom_code_discount_value =
        final_order_array.custom_code_discount_value;
      selectedOrder[0].service_charges = final_order_array.service_charges;
      selectedOrder[0].tip = final_order_array.tip;
      selectedOrder[0].delivery_charges = final_order_array.delivery_charges;

      selectedOrder[0].order_detail.forEach((item, index) => {
        item.item_name = itemsFromBizDelivery[index].dish_name;
        item.label = item.label === undefined ? "" : item.label;

        item.brand_id = itemsFromBizDelivery[index].brand_id;
        item.brand_name =
          item.brand_name === undefined
            ? item.item_brand === undefined
              ? ""
              : item.item_brand[0].brand_name
            : item.brand_name;

        item.category_id = itemsFromBizDelivery[index].category_id;
        item.comment =
          itemsFromBizDelivery[index].comment === undefined
            ? ""
            : itemsFromBizDelivery[index].comment;
        item.product_code = itemsFromBizDelivery[index].product_code;

        item.tax = itemsFromBizDelivery[index].tax;
        item.discount = itemsFromBizDelivery[index].discount;

        item.coupon_discount_value =
          itemsFromBizDelivery[index].coupon_discount_value;

        item.price = itemsFromBizDelivery[index].dish_price;

        item.quantity = itemsFromBizDelivery[index].dish_qty;

        item.total = parseFloat(itemsFromBizDelivery[index].dtotal);

        item.item_level_discount_value =
          itemsFromBizDelivery[index].item_level_discount_value;

        item.item_level_tax_value =
          itemsFromBizDelivery[index].item_level_tax_value;
        item.coupon_discount = itemsFromBizDelivery[index].coupon_discount;

        item.item_level_grand_total = parseFloat(
          itemsFromBizDelivery[index].item_level_grand_total
        );
        item.item_id = itemsFromBizDelivery[index].menu_item_id;
        item.weight_unit =
          itemsFromBizDelivery[index].weight_unit === null
            ? ""
            : itemsFromBizDelivery[index].weight_unit;
        item.weight_value =
          itemsFromBizDelivery[index].weight_value === ""
            ? "0.5"
            : itemsFromBizDelivery[index].weight_value;

        item.options =
          itemsFromBizDelivery[index].options === ""
            ? "{}"
            : JSON.stringify(itemsFromBizDelivery[index].options);
      });

      // update weight
      weightUpdate(selectedOrder[0]);
      setOrderFromAPI(selectedOrder);
      setSelectedOrderContext(selectedOrder[0]);
    }
    setCancelUpdateButtonToggle(true);

    if (actionType === "addItem") {
      // add new item
      setNotifyMessage("Item added successfully");
      setNotifyType("success");
      setRowSkeletonLoader(false);
    } else if (actionType === "editItem") {
      // edit item
      setNotifyMessage("Item updated successfully");
      setNotifyType("success");
      setOrderDetailLoader(false);
    } else if (actionType === "deleteItem") {
      //delete item
      setNotifyMessage("Item deleted");
      setNotifyType("warning");
      setOrderDetailLoader(false);
    } else {
      setNotifyMessage("Updated successfully");
      setNotifyType("success");
      setOrderDetailLoader(false);
    }

    setNotify(true);
  };

  const addItemClick = () => {
    setEditItemFlag(false);
    openAddEditModal();
  };

  const cancelOrderUpdate = async () => {
    setOrderDetailLoader(true);

    // single order API call
    const {
      data: { result },
    } = await getSingleOrderAPICall({
      data: getSingleOrderAPIPayload(),
    });

    setOrderFromAPI(result);
    setSelectedOrderContext(result[0]);

    // reset Weights
    weightUpdate(result[0]);
    setDiscountField(result[0]?.discount_value);
    setDeliveryChargesField(result[0]?.delivery_charges);

    setNotifyMessage("Order update cancelled");
    setNotifyType("warning");

    setCancelUpdateButtonToggle(false);
    setOrderDetailLoader(false);

    setNotify(true);
  };

  const updateOrder = async () => {
    // (type: any , and spread the order) did this because of order_update api payload
    let orderUpdatePayload: any = { ...orderFromAPI[0] };

    const selectedOrder = orderFromAPI[0];
    const selectedOrderDetail = orderFromAPI[0].order_detail;
    const { grand_total, pre_auth_trans, pre_auth, total, discount_value } =
      orderUpdatePayload;
    const calculatingMinimumSpend = total - discount_value;

    // Minimum Spend Error
    if (calculatingMinimumSpend < minimumSpend) {
      setNotifyMessage(
        `Your cart minimum spend is ${currency} ${minimumSpend}`
      );
      setNotifyType("error");
      setNotify(true);
      return;
    }

    // Pre-auth Error
    if (Number(pre_auth)) {
      // grand total is more than pre auth  amount
      const totalTransactionAmount = pre_auth_trans[0].trans_amount;

      if (grand_total > totalTransactionAmount) {
        setNotifyMessage(
          "Order cannot be updated because the grand total of the order is greater than the pre-authorized charge."
        );
        setNotifyType("error");
        setNotify(true);
        return;
      }
    }

    setOrderDetailLoader(true);

    // making order detail objects in array for order_update api payload
    let selectedOrderDetailApiFormat: any = [];

    selectedOrderDetail.forEach((item) => {
      let option = {};
      if (item.options && item.options !== "[]" && item.options !== "{}") {
        option = JSON.parse(item.options);
      }
      selectedOrderDetailApiFormat.push({
        comment: item.comment === undefined ? "" : item.comment,
        desc: "",
        tax: item.tax,
        discount: item.discount,
        coupon_discount: item.coupon_discount,
        coupon_discount_value: item.coupon_discount_value,
        item_level_grand_total: item.item_level_grand_total,
        item_level_tax_value: item.item_level_tax_value,
        item_level_discount_value: item.item_level_discount_value,
        label: item.label === undefined ? "" : item.label,
        dish_name: item.item_name,
        dish_price: item.price + "",
        dish_qty: item.quantity + "",
        item_cat_id:
          item.item_cat_id === undefined
            ? item.category_id
            : item.item_cat_id + "",
        category_id:
          item.item_cat_id === undefined
            ? item.category_id
            : item.item_cat_id + "",
        options: item.options ? option : "{}",
        mCurrency: "",
        menu_item_id: item.item_id + "",
        totalPrice: item.total + "",
        weight_value: item.weight_value,
        weight_unit: item.weight_unit,
      });
    });
    orderUpdatePayload.order = JSON.stringify({
      items: selectedOrderDetailApiFormat,
    });

    /*
      discount and totals
     */
    orderUpdatePayload.grandtotal = selectedOrder.grand_total;
    orderUpdatePayload.delivery_charges = selectedOrder.delivery_charges;
    orderUpdatePayload.custom_code_type = selectedOrder.custom_code_type;
    orderUpdatePayload.cash_change = selectedOrder.change;
    orderUpdatePayload.custom_code = selectedOrder.custom_code;

    orderUpdatePayload.delivery = "";
    orderUpdatePayload.discount_type = "";
    orderUpdatePayload.loyalty_points = "";
    orderUpdatePayload.transaction_timing = "";

    /*
      Other information
     */

    orderUpdatePayload.area = selectedOrder.user_area;
    orderUpdatePayload.bid = selectedOrder.eatout_bid;
    orderUpdatePayload.city = selectedOrder.user_city;
    orderUpdatePayload.comment = "";
    orderUpdatePayload.country = selectedOrder.user_country;
    orderUpdatePayload.guests = "";
    orderUpdatePayload.landline_phone = selectedOrder.landline_number;
    orderUpdatePayload.mobile_phone = selectedOrder.mobile_number;
    orderUpdatePayload.user_email = selectedOrder.user_email;
    orderUpdatePayload.pay_owner = "";
    orderUpdatePayload.pay_type = "";
    orderUpdatePayload.postal_code = selectedOrder.postal_code;
    orderUpdatePayload.ref = "";
    orderUpdatePayload.td_user_id = user_id;
    orderUpdatePayload.time = "";
    orderUpdatePayload.user_latitude = selectedOrder.user_latitude;
    orderUpdatePayload.user_longitude = selectedOrder.user_longitude;

    orderUpdatePayload.eatout_id = eatout_id;
    orderUpdatePayload.eatout_manager_id = user_id;
    try {
      // order update API call
      const { data } = await orderUpdateAPICall({
        data: orderUpdateAPIPayload({
          orders: [orderUpdatePayload],
        }),
      });

      if (data?.status === "1") {
        setNotifyMessage("Order updated successfully");
        setNotifyType("success");
        // log order update
      } else {
        setNotifyMessage("Order update failed");
        setNotifyType("error");
      }

      logDataChange({
        action: {
          url: "/order_update",
          method: "POST",
          payload: [orderUpdatePayload],
          response: JSON.stringify(data),
        },
        message: "Order Updated",
      });

      setCancelUpdateButtonToggle(false);
      setOrderDetailLoader(false);
      setNotify(true);
    } catch (err) {
      logDataChange({
        action: {
          url: "/order_update",
          method: "POST",
          payload: [orderUpdatePayload],
          response: JSON.stringify(err),
        },
        message: "Order Updated-Error",
      });
    }
  };

  const deleteOrderItem = (orderDetailId: number) => {
    discountOnFly = false;
    const selectedOrderDetail = orderFromAPI[0].order_detail.filter(
      (item) => item.order_detail_id !== String(orderDetailId)
    );

    if (selectedOrderDetail.length > 0) {
      let selectedOrders = orderFromAPI;

      selectedOrders[0].order_detail = selectedOrderDetail;

      setOrderFromAPI(selectedOrders);

      // make payload object for biz-delivery-calculation api
      makeOrderDetailObjForBizDeliveryAPI("deleteItem");
    } else {
      setNotifyMessage("Cart cannot be empty!");
      setNotifyType("error");
      setNotify(true);
    }
  };

  const addCurrency = (params: GridRenderCellParams) => {
    // for skeleton loader for a row to be added
    const lastItem = orderFromAPI[0].order_detail.slice(-1);

    return rowSkeletonLoader &&
      params.row.order_detail_id === lastItem[0].order_detail_id ? (
      <Skeleton animation="wave" height={15} width="90%" />
    ) : (
      <Stack sx={{ alignItems: "center" }}>
        <Stack direction="row" spacing={0.25} sx={{ alignItems: "flex-end" }}>
          <Typography
            sx={{ fontStyle: "normal", fontSize: "10px", color: "#757575" }}
          >
            {orderFromAPI[0] !== undefined && orderFromAPI[0].currency}
          </Typography>
          <Typography variant={"subtitle1"} sx={{ color: "#212121" }}>
            {parseFloat(params.value).toFixed(decimalPlaces)}
          </Typography>
        </Stack>
      </Stack>
    );
  };

  const weightFormatting = (params: GridRenderCellParams) => {
    // for skeleton loader for a row to be added
    const lastItem = orderFromAPI[0].order_detail.slice(-1);

    return rowSkeletonLoader &&
      params.row.order_detail_id === lastItem[0].order_detail_id ? (
      <Skeleton animation="wave" height={15} width="90%" />
    ) : params.row.weight_value && Number(params.row.weight_value) > 0 ? (
      <Typography variant="body1" sx={{ color: "#212121" }}>{`${parseFloat(
        params.row.weight_value
      )} ${params.row.weight_unit}`}</Typography>
    ) : (
      <Typography variant="body1" sx={{ color: "#212121" }}>
        -
      </Typography>
    );
  };

  const actionsButton = (params: GridRowParams) => {
    // returns order items editable actions only on pending & viewed statuses
    return (orderFromAPI[0].status.toLowerCase() === "pending" ||
      orderFromAPI[0].status.toLowerCase() === "viewed") &&
      !preventOrderUpdate
      ? [
          <GridActionsCellItem
            disabled={loaders}
            icon={<EditTwoTone />}
            label="Edit"
            showInMenu
            onClick={async () => {
              const item_id = Number(params.row.item_id);
              const row = params.row;

              // get single item API call (for edit item)
              const {
                data: { items },
              } = await singleItemCall({
                url: `/product_details?business_id=${eatout_id}&item_id=${item_id}&admin_id=${user_id}&source=biz`,
              });
              if (items && Array.isArray(items) && items?.length > 0) {
                if (items[0]?.status == "0") {
                  if (items[0]?.options.length > 0) {
                    setOptions(items[0]?.options);
                  }

                  setEditAbleItem([row]);
                  setEditItemFlag(true);
                  openAddEditModal();
                } else {
                  setNotifyMessage("Item not available");
                  setNotifyType("error");
                  setNotify(true);
                }
              } else {
                setNotifyMessage("Item Not Found");
                setNotifyType("error");
                setNotify(true);
              }
            }}
          />,
          <GridActionsCellItem
            disabled={loaders}
            icon={<DeleteTwoTone />}
            label="Delete"
            showInMenu
            onClick={() => deleteOrderItem(Number(params.id))}
          />,
        ]
      : [<div></div>];
  };

  const productFormatting = (params: GridRenderCellParams) => {
    // for skeleton loader for a row to be added
    const lastItem = orderFromAPI[0].order_detail.slice(-1);

    if (
      rowSkeletonLoader &&
      params.row.order_detail_id === lastItem[0].order_detail_id
    ) {
      return <Skeleton animation="wave" height={15} width="90%" />;
    } else {
      const row = params.row;
      const value = params.value;
      let options: any = {};
      const optionSets: any = [];
      let attributes: any = [];
      let count = 0;
      let innerOptionsName = "";

      if (row.attributes.length > 0) {
        row.attributes.map((attribute: any) => {
          for (const key in attribute) {
            attributes.push(` ${attribute[key]}`);
          }
        });
      }

      if (
        row.options &&
        row.options !== "[]" &&
        row.options !== "{}" &&
        Object.keys(row.options).length !== 0
      ) {
        options = JSON.parse(row.options);
        if (typeof options === "string") {
          options = JSON.parse(options);
        }
        for (const key in options) {
          let optionHeading = key;
          options[key].map((opt: any) => {
            innerOptionsName = "";
            let haveInnerOpt = opt.inner_options !== "" ? true : false;
            optionSets.push({
              heading: optionHeading ? optionHeading : "",
              name: opt.name,
              quantity: opt.quantity,
              price: opt.price,
              weight: opt.weight,
              haveInnerOptions: haveInnerOpt,
            });
            optionHeading = "";
            let inner_options = opt.inner_options;
            if (inner_options !== "") {
              for (const innerKey in inner_options) {
                inner_options[innerKey].map((innerOpt: any) => {
                  innerOptionsName = `${innerOptionsName} ${innerOpt.name} ${
                    parseFloat(innerOpt.price) > 0
                      ? "(" + currency + innerOpt.price + ")"
                      : ""
                  },`;
                });
              }
            }
            optionSets[count].inner_options = innerOptionsName;
            count++;
          });
        }
      }

      const returnInnerOptionSetInNewLine = (
        index: number,
        options: string
      ) => {
        // return InnerOptionSet In a NewLine with formatting
        const intoArray = options.split(",");
        return (
          intoArray &&
          intoArray.map((option) => (
            <Typography
              sx={{ color: "#212121" }}
              variant={"subtitle2"}
              key={index}
            >
              {option}
            </Typography>
          ))
        );
      };

      return (
        <Stack direction={"column"}>
          <Typography variant={"subtitle1"} sx={{ color: "#212121" }}>
            {value}
          </Typography>

          {attributes.length > 0 && (
            <Typography sx={{ mt: "5px" }} variant={"subtitle2"}>
              ({attributes.join()})
            </Typography>
          )}

          {optionSets.length > 0 && (
            <Stack //option sets stack
              direction={"column"}
              spacing={1}
            >
              {optionSets.map((e: any, index: number) => {
                return e.haveInnerOptions ? (
                  <>
                    {/* Heading */}
                    {e.heading && (
                      <Typography
                        sx={{
                          display: "flex",
                          marginBottom: "4px",
                          width: "fit-content",
                          maxWidth: "230px",
                          color: "#212121",
                          border: "1px solid #DB154D",
                          backgroundColor: "rgba(219, 21, 77, 0.05)",
                          padding: "4px 8px",
                          borderRadius: "4px",
                        }}
                        variant={"h6"}
                        key={index}
                      >
                        {e.heading}
                      </Typography>
                    )}
                    <Box
                      sx={{
                        width: "fit-content",
                        height: "fit-content",
                        boxSizing: "border-box",
                        mt: "4px !important",
                        ml: "0px !important",
                        p: "4px",
                        color: "#212121",
                        background: "#F8F5FC",
                        border: "1px solid #673AB7",
                        borderRadius: "4px",
                      }}
                    >
                      {/* option set */}
                      <Typography
                        sx={{ color: "#212121" }}
                        variant={"subtitle1"}
                        key={index}
                      >
                        {e.quantity == 1
                          ? e.name
                          : e.name && e.name.includes("Special Instructions")
                          ? e.name
                          : `${e.quantity} x ${e.name} `}
                        {e.inner_options === "" ? "" : ":"}

                        {e.weight !== "" && e.weight !== undefined && (
                          <div>{`weight ${
                            parseInt(e.weight.split(" ")[0]) *
                            parseInt(e.quantity)
                          } ${e.weight.split(" ")[1]}`}</div>
                        )}
                      </Typography>

                      {/* inner option set */}
                      {e.inner_options === ""
                        ? ""
                        : returnInnerOptionSetInNewLine(index, e.inner_options)}
                    </Box>
                  </>
                ) : (
                  <>
                    {e.heading && (
                      <Typography
                        sx={{
                          display: "flex",
                          marginBottom: "4px",
                          width: "fit-content",
                          maxWidth: "230px",
                          color: "#212121",
                          border: "1px solid #DB154D",
                          backgroundColor: "rgba(219, 21, 77, 0.05)",
                          padding: "4px 8px",
                          borderRadius: "4px",
                        }}
                        variant={"h6"}
                        key={index}
                      >
                        {e.heading}
                      </Typography>
                    )}
                    <Typography
                      sx={{
                        maxWidth: "278px",
                        height: "fit-content",
                        boxSizing: "border-box",
                        mt: "4px !important",
                        marginLeft: "0px !important",
                        p: "4px",
                        color: "#212121",
                        background: "#F8F5FC",
                        border: "1px solid #673AB7",
                        borderRadius: "4px",
                        fontFamily: "Roboto",
                        fontStyle: "normal",
                        fontWeight: "500",
                        fontSize: "12px",
                      }}
                      key={index}
                    >
                      {e.quantity == 1
                        ? `${e.name}`
                        : e.name && e.name.includes("Special Instructions")
                        ? `${e.name}`
                        : `${e.quantity} x ${e.name} `}
                      {e.inner_options === "" ? "" : ":"}

                      {e.weight !== "" && e.weight !== undefined && (
                        <div>{`weight ${
                          parseInt(e.weight.split(" ")[0]) *
                          parseInt(e.quantity)
                        } ${e.weight.split(" ")[1]}`}</div>
                      )}
                    </Typography>
                  </>
                );
              })}
            </Stack>
          )}

          {row.comment !== undefined && row.comment && (
            <Stack
              direction={"row"}
              spacing={0.4}
              sx={{ mt: "5px", flexWrap: "wrap" }}
            >
              <Typography variant={"h6"}>Instructions:</Typography>
              <Typography variant={"subtitle2"}>{row.comment}</Typography>
            </Stack>
          )}

          {((row.item_level_discount_value &&
            Number(row.item_level_discount_value) > 0) ||
            (row.tax && Number(row.tax) > 0)) && (
            <Stack
              direction={"row"}
              spacing={0.5}
              sx={{ alignItems: "center", mt: "5px", flexWrap: "wrap" }}
            >
              {Number(row.item_level_discount_value) > 0 && (
                <Stack direction={"row"} spacing={0.4}>
                  <Typography variant={"h6"}>Discount:</Typography>
                  <Typography variant={"subtitle2"}>
                    {`(${orderFromAPI[0].currency} ${parseFloat(
                      row.item_level_discount_value
                    ).toFixed(2)})`}
                  </Typography>
                </Stack>
              )}

              {row.tax && Number(row.tax) > 0 && (
                <Stack direction={"row"} spacing={0.4}>
                  <Typography variant={"h6"}>Tax:</Typography>
                  <Typography variant={"subtitle2"}>
                    ({parseFloat(row.tax).toFixed(2)}%)
                  </Typography>
                </Stack>
              )}
            </Stack>
          )}

          {row.product_code && (
            <Stack
              direction={"row"}
              spacing={0.4}
              sx={{ alignItems: "center", mt: "5px" }}
            >
              <Typography variant={"h6"}>SKU:</Typography>
              <Typography variant={"subtitle2"}>{row.product_code}</Typography>
            </Stack>
          )}
        </Stack>
      );
    }
  };

  // returns item number for table
  const getItemsCount = (itemId: string) => {
    const itemIndex = orderFromAPI[0].order_detail.findIndex(
      (item) => item.order_detail_id === itemId
    );

    return itemIndex + 1;
  };

  const rowSkeleton = (params: GridRenderCellParams) => {
    if (rowSkeletonLoader) {
      const lastItem = orderFromAPI[0].order_detail.slice(-1);
      if (params.row.order_detail_id === lastItem[0].order_detail_id) {
        return <Skeleton animation="wave" height={15} width="90%" />;
      }
    }
    return (
      <Typography variant="body1" sx={{ color: "#212121" }}>
        {params.field === "itemCount"
          ? getItemsCount(params.row.order_detail_id.toString())
          : params.value}
      </Typography>
    );
  };

  const columns: GridColumns = [
    {
      field: "itemCount",
      headerName: "Item #",
      headerAlign: "right",
      align: "right",
      headerClassName: classes.tableItemNoColumn,
      cellClassName: classes.tableItemNoColumn,
      flex: 0.46,
      minWidth: 75,
      sortable: false,
      renderCell: rowSkeleton,
    },
    {
      field: "item_name",
      headerName: "Item Name",
      flex: 2,
      minWidth: 250,
      sortable: false,
      renderCell: productFormatting,
    },
    {
      field: "weight_value",
      headerName: "Weight",
      headerAlign: "right",
      align: "right",
      flex: 0.6,
      minWidth: 60,
      sortable: false,
      renderCell: weightFormatting,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      headerAlign: "right",
      align: "right",
      flex: 0.7,
      minWidth: 80,
      sortable: false,
      renderCell: rowSkeleton,
    },
    {
      field: "price",
      headerName: "Price",
      headerAlign: "right",
      align: "right",
      flex: 1,
      minWidth: 160,
      sortable: false,
      renderCell: addCurrency,
    },
    {
      field: "total",
      headerName: "Amount",
      headerAlign: "right",
      align: "right",
      flex: 1,
      minWidth: 160,
      sortable: false,
      renderCell: addCurrency,
    },
    {
      field: "action",
      headerName: "",
      type: "actions",
      align: "right",
      headerAlign: "right",
      minWidth: 30,
      width: 30,
      sortable: false,
      getActions: actionsButton,
    },
  ];

  const closeDetailModal = () => {
    if (!cancelUpdateButtonToggle) {
      // if order is not in updating state
      setOrderDetailModal((state) => !state);
      setPreventOrderUpdate(false);
    } else {
      setNotifyMessage("Cancel/Update order to proceed");
      setNotifyType("error");
      setNotify(true);
    }
  };

  const downloadPdfComponent = () => {
    const { eatout_name } = JSON.parse(localStorage.getItem("businessInfo")!);
    const { order_id } = orderFromAPI[0];
    let blob = pdf(
      <PackingSlip
        packingSlipData={orderFromAPI}
        pdfType={"pdf"}
        branchesAccessDetails={branchesAccessDetails}
      />
    )
      .toBlob()
      .then((e: Blob) => {
        let pdfUrl = URL.createObjectURL(e);

        let tempLink = document.createElement("a");
        tempLink.href = pdfUrl;
        tempLink.setAttribute(
          "download",
          `${eatout_name}-order-${order_id}.pdf`
        );
        tempLink.click();
      });
  };

  const openAddEditModal = () => setAddEditItemModal((state) => !state);
  const printPreviewModal = () => setPackingSlip((state) => !state);

  const handlePickupChange = (e: {
    target: { name: string; value: string };
  }) => {
    const { name, value } = e.target;

    if (value) setPickupTime(value);
  };

  const handleCommentChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setPickupComment(e.target.value);
  };

  const handleStaffNoteChange = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setStaffNote(e.target.value);
  };

  const closeOrderDetailsModel = () => {
    setCustomerDetailLoader(false);
    togglePickupModal();

    setNotifyMessage("Details updated successfully");
    setNotifyType("success");
    setNotify(true);
  };

  const updateOrderTypeDetails = async () => {
    setCustomerDetailLoader(true);

    if (staffNote) {
      handleCustomerDetailUpdate({}, false);
    }

    if (orderFromAPI[0]?.order_type !== "pickup") {
      closeOrderDetailsModel();
      return;
    }

    const {
      data: { status },
    } = await orderPickupChangeAPICall({
      data: pickupChangePayload(),
    });

    if (status == "1") {
      let selectedOrder = [...orderFromAPI];
      selectedOrder[0].pickup_time = pickuptime;

      setOrderFromAPI(selectedOrder);

      closeOrderDetailsModel();
    }
  };

  const toggleDeliveryChargesModal = () => {
    /*
      if delivery charges edit and left blank then close modal
   */
    if (
      orderFromAPI[0].canada_post == "0" &&
      orderFromAPI[0].delivery_charges &&
      !deliveryChargeField
    ) {
      setDeliveryChargesField(orderFromAPI[0].delivery_charges);
    } else if (deliveryChargeField !== orderFromAPI[0].delivery_charges) {
      /*
      if delivery charges edit and then close modal
   */
      setDeliveryChargesField(orderFromAPI[0].delivery_charges);
    } else if (
      orderFromAPI[0].canada_post == "1" &&
      orderFromAPI[0].delivery_charges !== canadaPostDeliveryCharges
    ) {
      /*
        if canada post charges edit and close modal without update
       */
      setCanadaPostDeliveryCharges(orderFromAPI[0].delivery_charges);
    }

    // close delivery charges modal
    setDeliveryChargesModal(false);

    // remove any errors
    setFieldError({ ...fieldError, deliveryCharges: "" });
  };

  const weightUpdate = (order: any) => {
    const { order_detail: orderDetails } = order;

    let totalWeightInGrams = 0;
    let mostFrequentUnit = "";
    const unitCounts: { [key: string]: number } = {};

    // iterate items to calculate weight
    orderDetails?.forEach((item: OrderListingResponseOrderDetail) => {
      const weightValue = Number(item.weight_value) * Number(item.quantity);
      const weightUnit = item.weight_unit?.trim()?.toLowerCase();

      // verify if weight value & weight unit exists
      if (weightValue && weightUnit) {
        const weightInGrams = convertToGrams(weightValue, weightUnit);

        totalWeightInGrams += weightInGrams;

        if (unitCounts[weightUnit]) {
          unitCounts[weightUnit]++;
        } else {
          unitCounts[weightUnit] = 1;
        }
      }
    });

    // check the used weight units count
    if (Object.keys(unitCounts)?.length) {
      mostFrequentUnit = Object.keys(unitCounts).reduce((a, b) =>
        unitCounts[a] > unitCounts[b] ? a : b
      );

      mostFrequentUnit = mostFrequentUnit?.trim()?.toLowerCase();
    }

    // convert weight into frequently used unit count
    if (totalWeightInGrams && mostFrequentUnit) {
      const totalWeightInFrequentUnit = convertFromGrams(
        totalWeightInGrams,
        mostFrequentUnit
      );

      setTotalWeight(totalWeightInFrequentUnit);
      setWeightUnit(mostFrequentUnit);
    }
  };

  const handleDiscountUpdate = () => {
    discountOnFly = true;
    makeOrderDetailObjForBizDeliveryAPI("", "1");
    toggleDiscountModal();
  };

  const handleDiscountField = (e: {
    target: { value: React.SetStateAction<string> };
  }) => {
    if (/^[0-9.|()&^]*$/.test(e.target.value.toString()) && e.target.value) {
      setDiscountField(e.target.value);
    } else {
      setDiscountField("");
    }
  };

  // Update the handler function
  const handlePrinterSelection = (event: {
    target: { value: string };
  }): void => {
    selectedPrinterRef.current = event.target.value;
  };

  // function to select printer
  const savePrinterSelection = (): void => {
    localStorage.setItem("printerType", selectedPrinterRef.current);

    setTogglePrinterModal(false);

    // call print function
    handleOrderPrint();
  };

  // function to select print format
  const handleOrderPrint = (): void => {
    const printerType = localStorage.getItem("printerType");

    if (!printerType) {
      setTogglePrinterModal(true);

      return;
    }

    if (printerType === "standard") {
      setPackingSlip((state) => !state);
    } else {
      // function Call to print order from thermal printer
      handlePrint();
    }
  };

  return (
    <>
      {notify && (
        <Notify
          message={notifyMessage}
          type={notifyType}
          notify={notify}
          closeNotify={closeNotify}
        />
      )}

      {/* Add edit item modal */}
      {openAddEditItemModal && (
        <AddEditItem
          openAddEditItemModal={openAddEditItemModal}
          setAddEditItemModal={setAddEditItemModal}
          getNewItemCallback={getNewItemCallback}
          getEditItemCallback={getEditItemCallback}
          editItemFlag={editItemFlag}
          branchId={orderFromAPI?.[0]?.eatout_bid}
        />
      )}

      {/* Order Detail Modal */}
      <Modal open={orderDetailModal} onClose={closeDetailModal}>
        <Paper style={{ height: "100%", overflowX: "auto" }}>
          <MainCard
            dividerSX={{ m: "unset", display: "none" }}
            headerSX={{ p: "unset !important", mb: "32px" }}
            contentSX={{
              "& .MuiCardContent-root": {
                p: "unset !important",
              },
              m: "unset",
              p: "unset !important",
            }}
            sx={mainCardSX}
            title={
              <>
                <Grid container>
                  <Grid item xs={12} sx={orderDetailHeaderParent}>
                    <Grid item xs={12} md={7} sx={orderIdGridStyles}>
                      {orderFromAPI.length === 0 ? (
                        <OrderIdSectionSkeleton />
                      ) : (
                        <Stack
                          direction={{ xs: "column", lg: "row" }}
                          sx={orderIdStackStyles}
                        >
                          <Stack direction={"column"}>
                            <Typography variant={isScreenSmall ? "h2" : "h1"}>
                              Order
                              {orderFromAPI[0] !== undefined &&
                                ` ${orderFromAPI[0].order_id}`}
                            </Typography>

                            <Typography
                              variant={"subtitle1"}
                              sx={{ fontWeight: "400" }}
                            >
                              {orderFromAPI[0] !== undefined &&
                                moment(orderFromAPI[0].date).format(
                                  "MMM Do, YYYY hh:mm a"
                                )}
                            </Typography>
                          </Stack>

                          <Stack direction={"row"} sx={headerOrderInfoStack}>
                            <Typography
                              variant={"h6"}
                              sx={{
                                ...orderDetailsHeading,
                                backgroundColor: `${
                                  orderFromAPI[0] !== undefined &&
                                  orderFromAPI[0].is_paid == "1"
                                    ? "#D2FFDF"
                                    : "#FFD5D2"
                                }`,
                                color: `${
                                  orderFromAPI[0] !== undefined &&
                                  orderFromAPI[0].is_paid == "1"
                                    ? "#00C853"
                                    : "#C80000"
                                }`,
                              }}
                            >
                              {orderFromAPI[0] !== undefined &&
                              orderFromAPI[0].is_paid == "1"
                                ? "Paid"
                                : "Unpaid"}
                            </Typography>

                            {orderFromAPI[0]?.invoice_id && (
                              <Typography
                                variant={"h6"}
                                sx={subscriptionTypeStyles}
                              >
                                {`Txn #${orderFromAPI[0]?.invoice_id}`}
                              </Typography>
                            )}

                            {orderFromAPI[0]?.subscription && (
                              <Typography
                                variant={"h6"}
                                sx={subscriptionTypeStyles}
                              >
                                {getSubscription(orderFromAPI[0]?.subscription)}
                              </Typography>
                            )}
                          </Stack>
                        </Stack>
                      )}
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={5}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: { xs: "start", md: "end" },
                      }}
                    >
                      <ExcelExport
                        tableData={OrderDetailColumns}
                        orderDetailData={(() => {
                          if (orderFromAPI.length > 0) return orderFromAPI[0];
                        })()}
                        exportType={"OrderDetail"}
                      />

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{
                          cursor: "pointer",
                          alignItems: "center",
                          ml: { xs: "16px", md: "24px" },
                        }}
                        onClick={downloadPdfComponent}
                      >
                        <PictureAsPdfTwoTone
                          className={
                            classes.pdf_print_user_phone_location_IconColor
                          }
                        />
                        <Typography
                          variant="h5"
                          className={classes.downloadPdf}
                        >
                          Download PDF
                        </Typography>
                      </Stack>

                      <Tooltip
                        message={
                          <Stack sx={orderPrintStack}>
                            <Typography variant="h6" sx={{ color: "#F5F5F5" }}>
                              Change printer
                            </Typography>

                            <Button
                              onClick={() => setTogglePrinterModal(true)}
                              sx={orderPrinterButton}
                            >
                              Update
                            </Button>
                          </Stack>
                        }
                      >
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{
                            cursor: "pointer",
                            alignItems: "center",
                            ml: "24px",
                            display: { xs: "none", md: "flex" },
                          }}
                          onClick={handleOrderPrint}
                        >
                          <PrintTwoTone
                            className={
                              classes.pdf_print_user_phone_location_IconColor
                            }
                          />
                          <Typography className={classes.printHeading}>
                            Print
                          </Typography>
                        </Stack>
                      </Tooltip>

                      <Stack
                        sx={{
                          cursor: "pointer",
                          alignItems: "center",
                          ml: "48px",
                          position: { xs: "absolute", md: "unset" },
                          top: 0,
                          right: 0,
                        }}
                      >
                        <IconButton
                          sx={{ p: "unset" }}
                          onClick={closeDetailModal}
                        >
                          <HighlightOffTwoTone
                            sx={{ color: "#D84315" }}
                            fontSize="large"
                          />
                        </IconButton>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            }
          >
            <Grid container>
              <Grid item xs={12} sx={{ display: { md: "flex" } }}>
                <Grid
                  item
                  xs={12}
                  md={7.3}
                  lg={8.3}
                  sx={{ mb: { xs: "16px", md: "0" } }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: { xs: "start", lg: "center" },
                      border: "1px solid #EEEEEE",
                      borderRadius: "8px",
                      p: "10px 13px 10px 18px",
                      mb: "12px",
                    }}
                  >
                    <Grid item xs={9} lg={11}>
                      {orderFromAPI.length === 0 ? (
                        <UserDetailsSkeleton />
                      ) : (
                        <Stack
                          spacing={2}
                          direction={{ xs: "column", lg: "row" }}
                          divider={
                            <Divider
                              orientation="vertical"
                              sx={{
                                border: "1px solid #EEEEEE",
                                display: { xs: "none", lg: "block" },
                              }}
                              flexItem
                            />
                          }
                        >
                          {orderFromAPI[0] !== undefined &&
                            orderFromAPI[0].name && (
                              <Stack
                                direction="row"
                                sx={{ alignItems: "center" }}
                                spacing={1}
                              >
                                <AccountCircleTwoTone
                                  className={
                                    classes.pdf_print_user_phone_location_IconColor
                                  }
                                />
                                <Typography variant={"h5"}>
                                  {orderFromAPI[0].name}
                                </Typography>
                              </Stack>
                            )}

                          <Stack
                            direction="row"
                            sx={{ alignItems: "center" }}
                            spacing={1}
                          >
                            <SmartphoneTwoTone
                              className={
                                classes.pdf_print_user_phone_location_IconColor
                              }
                              fontSize="small"
                            />
                            <Typography
                              variant={"h5"}
                              sx={{
                                maxWidth: "107px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {orderFromAPI[0] !== undefined &&
                                orderFromAPI[0].mobile_number}
                            </Typography>
                          </Stack>

                          {/* Email */}
                          {orderFromAPI[0] !== undefined &&
                            orderFromAPI[0].user_email && (
                              <Stack
                                direction="row"
                                sx={{
                                  alignItems: "center",
                                }}
                                spacing={1}
                              >
                                <MailTwoToneIcon
                                  className={
                                    classes.pdf_print_user_phone_location_IconColor
                                  }
                                />
                                <Typography variant={"h5"}>
                                  {orderFromAPI[0].user_email}
                                </Typography>
                              </Stack>
                            )}

                          {/* Address */}
                          {orderFromAPI[0] !== undefined &&
                            orderFromAPI[0].address && (
                              <Stack
                                direction="row"
                                sx={{
                                  alignItems: "center",
                                }}
                                spacing={1}
                              >
                                <PinDropTwoTone
                                  className={
                                    classes.pdf_print_user_phone_location_IconColor
                                  }
                                />
                                <Typography variant={"h5"}>
                                  {orderFromAPI[0].address}
                                </Typography>
                              </Stack>
                            )}
                        </Stack>
                      )}
                    </Grid>

                    <Grid item xs={3} lg={1}>
                      <Stack direction="row" sx={{ justifyContent: "end" }}>
                        {/* to hide button for  skeleton loader */}
                        {orderFromAPI.length > 0 && (
                          <Button
                            variant="contained"
                            startIcon={<EditTwoTone />}
                            sx={{
                              background: "#F5F5F5 ",
                              color: "#212121",
                              p: "9px 20px",
                              "&:hover": {
                                backgroundColor: "#F5F5F5",
                              },
                            }}
                            onClick={toggleCustomerDetailModal}
                          >
                            Edit
                          </Button>
                        )}
                      </Stack>
                    </Grid>
                  </Box>

                  <Box
                    sx={{
                      border: "1px solid #EEEEEE",
                      borderRadius: "8px",
                      p: "17px 12px 24px 16px",
                      mb: "16px",
                      boxSizing: "border-box",
                    }}
                  >
                    <Stack direction="column">
                      {orderFromAPI.length === 0 ? (
                        <OrderDeliveryDetailsSkeleton />
                      ) : (
                        <>
                          {/* delivery details heading stack */}
                          <Stack
                            direction="row"
                            sx={{
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Stack direction="row">
                              {orderFromAPI[0] !== undefined && (
                                <Typography variant="h4">
                                  {`${capitalizeFirstLetter(
                                    orderFromAPI[0].order_type
                                  )} Details`}
                                </Typography>
                              )}
                            </Stack>

                            <Stack>
                              <Button
                                variant="contained"
                                startIcon={<EditTwoTone />}
                                sx={{
                                  background: "#F5F5F5 ",
                                  color: "#212121",
                                  p: "9px 20px",

                                  "&:hover": {
                                    backgroundColor: "#F5F5F5",
                                  },
                                }}
                                onClick={togglePickupModal}
                              >
                                Edit
                              </Button>
                            </Stack>
                          </Stack>

                          <Stack // order type stack
                            direction="row"
                            sx={{ mt: "16px" }}
                          >
                            <Typography variant="subtitle1">
                              Order type:
                            </Typography>
                            <Typography variant="h5" sx={{ ml: "52px" }}>
                              {orderFromAPI[0] !== undefined &&
                                capitalizeFirstLetter(
                                  orderFromAPI[0].order_type
                                )}
                            </Typography>
                          </Stack>

                          {orderFromAPI[0] !== undefined &&
                            orderFromAPI[0].order_type_flag === "0" && //for delivery (0) & for pickup (1)
                            orderFromAPI[0].delivery_date !==
                              "0000-00-00 00:00:00" &&
                            orderFromAPI[0].delivery_date !== "" && (
                              <Stack // delivery time stack
                                direction="row"
                                sx={{ mt: "16px" }}
                              >
                                <Typography variant="subtitle1">
                                  Delivery Time:
                                </Typography>
                                <Typography variant="h5" sx={{ ml: "32px" }}>
                                  {formatDateTimeString(
                                    orderFromAPI[0]?.delivery_date
                                  )}
                                </Typography>
                              </Stack>
                            )}

                          {orderFromAPI[0] !== undefined &&
                            orderFromAPI[0].order_type_flag === "1" && //for delivery (0) & for pickup (1)
                            orderFromAPI[0].pickup_time !==
                              "0000-00-00 00:00:00" &&
                            orderFromAPI[0].pickup_time !== "" && (
                              <Stack // pickup time stack
                                direction="row"
                                sx={{ mt: "16px" }}
                              >
                                <Typography variant="subtitle1">
                                  Pickup Time:
                                </Typography>
                                <Typography variant="h5" sx={{ ml: "38px" }}>
                                  {formatDateTimeString(
                                    orderFromAPI[0]?.pickup_time
                                  )}
                                </Typography>
                              </Stack>
                            )}

                          {orderFromAPI[0] !== undefined &&
                            orderFromAPI[0].note && (
                              <Stack //Note Stack
                                direction="row"
                                sx={{ mt: "16px" }}
                              >
                                <Typography variant="subtitle1">
                                  Note:
                                </Typography>
                                <Typography variant="h5" sx={{ ml: "86px" }}>
                                  {orderFromAPI[0].note}
                                </Typography>
                              </Stack>
                            )}

                          <Stack //Note Stack
                            direction="row"
                            sx={{ mt: "16px" }}
                          >
                            <Typography variant="subtitle1">
                              Staff Note:
                            </Typography>

                            <Typography variant="h5" sx={{ ml: "50px" }}>
                              {orderFromAPI[0]?.landline_number}
                            </Typography>
                          </Stack>
                        </>
                      )}
                    </Stack>
                  </Box>

                  <MainCard
                    dividerSX={{ m: "0px 0px 0px 0px !important" }}
                    headerSX={{ p: "unset !important", mb: "20px" }}
                    contentSX={{
                      "& .MuiCardContent-root": {
                        p: "unset !important",
                      },
                      m: "unset",
                      p: "unset !important",
                    }}
                    sx={{
                      m: "unset",
                      p: "20px 16px 16px",
                      borderColor: "#EEEEEE",
                    }}
                    title={
                      <Stack
                        sx={{
                          flexDirection: { xs: "column", md: "row" },
                          justifyContent: {
                            xs: "unset",
                            md: "space-between",
                          },
                          alignItems: { xs: "unset", md: "center" },
                        }}
                      >
                        {orderFromAPI.length === 0 ? (
                          <TableBoxHeaderSkeleton />
                        ) : (
                          <>
                            <Typography
                              variant={"h4"}
                              sx={{ mb: { xs: "12px", md: "0" } }}
                            >
                              Order Items
                            </Typography>

                            <Stack
                              sx={{
                                flexDirection: {
                                  xs: "column-reverse",
                                  md: "row",
                                },
                              }}
                            >
                              {cancelUpdateButtonToggle && (
                                <>
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={cancelOrderUpdate}
                                    sx={{
                                      p: "10px 23px",
                                      fontFamily: "Roboto",
                                      fontStyle: "normal",
                                      fontWeight: 500,
                                      fontSize: "13px",
                                      backgroundColor: "#D84315",
                                      mb: { xs: "12px", md: "0" },

                                      "&:hover": {
                                        backgroundColor: "#D84315",
                                      },
                                    }}
                                  >
                                    Cancel Update
                                  </Button>
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={updateOrder}
                                    sx={{
                                      p: "10px 26px",
                                      fontFamily: "Roboto",
                                      fontStyle: "normal",
                                      fontWeight: 500,
                                      fontSize: "13px",
                                      backgroundColor: "#24335E",
                                      mb: { xs: "12px", md: "0" },
                                      ml: { xs: "0", md: "12px" },

                                      "&:hover": {
                                        backgroundColor: "#24335E",
                                      },
                                    }}
                                  >
                                    Update Order
                                  </Button>
                                </>
                              )}

                              <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<AddTwoTone />}
                                onClick={addItemClick}
                                disabled={
                                  ((orderFromAPI[0].status.toLowerCase() ===
                                    "pending" ||
                                    orderFromAPI[0].status.toLowerCase() ===
                                      "viewed") &&
                                  !preventOrderUpdate
                                    ? false
                                    : true) || loaders
                                }
                                sx={{
                                  p: "10px 24px",
                                  fontFamily: "Roboto",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  fontSize: "13px",
                                  mb: { xs: "12px", md: "0" },
                                  ml: { xs: "0", md: "12px" },
                                }}
                              >
                                Add Item
                              </Button>
                            </Stack>
                          </>
                        )}
                      </Stack>
                    }
                  >
                    {orderFromAPI.length === 0 ? (
                      <TableSkeleton />
                    ) : (
                      <Box sx={productItemsTableStyle}>
                        <DataGrid
                          rows={(() => {
                            if (!orderFromAPI[0]) return [];
                            return orderFromAPI[0].order_detail;
                          })()}
                          getRowId={(row: any) => row.order_detail_id}
                          columns={columns}
                          autoHeight
                          disableColumnMenu
                          hideFooterSelectedRowCount
                          hideFooter
                          components={{
                            LoadingOverlay: linearLoader,
                          }}
                          loading={orderDetailLoader}
                        />
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        background: "#F5F5F5",
                        borderRadius: "8px",
                        p: "24px 31px",
                        mt: "2px",
                      }}
                    >
                      <Grid item xs={12} md={7.5} lg={5.5}>
                        {orderFromAPI.length === 0 ? (
                          <CalculationSectionSkeleton />
                        ) : (
                          <>
                            <Stack
                              direction={"row"}
                              sx={{ justifyContent: "space-between" }}
                            >
                              <Stack direction={"column"}>
                                <Stack // Sub Total
                                  direction={"row"}
                                  sx={{
                                    ...responsiveAlignmentStart,
                                    mt: "0",
                                  }}
                                >
                                  <Typography variant="subtitle1">
                                    Sub Total
                                  </Typography>
                                </Stack>

                                {orderFromAPI[0] !== undefined &&
                                  (Number(orderFromAPI[0].loyalty_points) > 0 ||
                                    Number(
                                      orderFromAPI[0].custom_code_discount_value
                                    ) > 0) && (
                                    <Stack // Loyalty Points && Custom code discount
                                      direction={"row"}
                                      sx={responsiveAlignmentStart}
                                    >
                                      <Typography // switch loyalty points and custom code
                                        variant="subtitle1"
                                      >
                                        {parseInt(
                                          orderFromAPI[0].loyalty_points
                                        ) > 0
                                          ? `Loyalty Points (${orderFromAPI[0].loyalty_points})`
                                          : `Coupon Code ${validateCouponCode(
                                              orderFromAPI[0].custom_code
                                            )}`}
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  totalWeight > 0 && (
                                    <Stack // Total weight
                                      direction={"row"}
                                      sx={responsiveAlignmentStart}
                                    >
                                      <Typography variant="subtitle1">
                                        Total Weight
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined && (
                                  <Stack // Discount
                                    direction={"row"}
                                    sx={responsiveAlignmentStart}
                                  >
                                    <Typography variant="subtitle1">
                                      Discount{" "}
                                      {Number(orderFromAPI[0].discount)
                                        ? `(${orderFromAPI[0].discount} %)`
                                        : ""}
                                    </Typography>
                                    {(selectedOrderContext.status ===
                                      "Pending" ||
                                      selectedOrderContext.status ===
                                        "viewed") &&
                                      !preventOrderUpdate && (
                                        <IconButton
                                          sx={{ p: "unset", ml: "5px" }}
                                          onClick={toggleDiscountModal}
                                          disabled={loaders}
                                        >
                                          <EditTwoTone
                                            sx={{ fontSize: "1.3rem" }}
                                          />
                                        </IconButton>
                                      )}
                                  </Stack>
                                )}

                                {orderFromAPI[0].order_type_flag === "0" && (
                                  <Stack // Delivery Charges
                                    direction={"row"}
                                    sx={responsiveAlignmentStart}
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      sx={{
                                        display: "flex",
                                        alignItems: "end",
                                      }}
                                    >
                                      Delivery Charges
                                    </Typography>
                                    {(selectedOrderContext.status ===
                                      "Pending" ||
                                      selectedOrderContext.status ===
                                        "viewed") &&
                                      !preventOrderUpdate && (
                                        <IconButton
                                          sx={{ p: "unset", ml: "5px" }}
                                          onClick={openDeliveryModal}
                                          disabled={loaders}
                                        >
                                          <EditTwoTone
                                            sx={{ fontSize: "1.3rem" }}
                                          />
                                        </IconButton>
                                      )}
                                  </Stack>
                                )}

                                {orderFromAPI[0] !== undefined &&
                                  Number(orderFromAPI[0].tax_value) > 0 && (
                                    <Stack // Tax
                                      direction={"row"}
                                      sx={responsiveAlignmentStart}
                                    >
                                      <Typography variant="subtitle1">
                                        Tax ({orderFromAPI[0].tax} %)
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  Number(orderFromAPI[0].tip) > 0 && (
                                    <Stack // Tip
                                      direction={"row"}
                                      sx={responsiveAlignmentStart}
                                    >
                                      <Typography variant="subtitle1">
                                        Tip
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  Number(orderFromAPI[0].service_charges) >
                                    0 && (
                                    <Stack // Service Charges
                                      direction={"row"}
                                      sx={responsiveAlignmentStart}
                                    >
                                      <Typography variant="subtitle1">
                                        Service Charges
                                      </Typography>
                                    </Stack>
                                  )}
                              </Stack>

                              <Stack direction={"column"}>
                                <Stack // Sub Total
                                  direction="row"
                                  spacing={0.25}
                                  sx={{
                                    ...responsiveAlignmentEnd,
                                    mt: "0",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: "Roboto",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "12px",
                                      color: "#757575",
                                    }}
                                  >
                                    {orderFromAPI[0] !== undefined &&
                                      orderFromAPI[0].currency}
                                  </Typography>
                                  <Typography variant="h4">
                                    {orderFromAPI[0] !== undefined &&
                                      parseFloat(orderFromAPI[0].total).toFixed(
                                        decimalPlaces
                                      )}
                                  </Typography>
                                </Stack>

                                {orderFromAPI[0] !== undefined &&
                                  (Number(orderFromAPI[0].loyalty_points) > 0 ||
                                    Number(
                                      orderFromAPI[0].custom_code_discount_value
                                    ) > 0) && (
                                    <Stack // Loyalty Points && Custom code discount
                                      direction={"row"}
                                      spacing={0.25}
                                      sx={responsiveAlignmentEnd}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: "Roboto",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "12px",
                                          color: "#757575",
                                        }}
                                      >
                                        {orderFromAPI[0] !== undefined &&
                                          orderFromAPI[0].currency}
                                      </Typography>
                                      <Typography variant="h4">
                                        {Number(
                                          orderFromAPI[0]
                                            .custom_code_discount_value
                                        ).toFixed(decimalPlaces)}
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  totalWeight > 0 && (
                                    <Stack // Total weight
                                      direction={"row"}
                                      spacing={0.25}
                                      sx={responsiveAlignmentEnd}
                                    >
                                      <Typography variant="h4">
                                        {`${totalWeight} ${weightUnit}`}
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined && (
                                  <Stack // discount
                                    direction={"row"}
                                    spacing={0.25}
                                    sx={responsiveAlignmentEnd}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: "Roboto",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: "12px",
                                        color: "#757575",
                                      }}
                                    >
                                      {orderFromAPI[0].currency}
                                    </Typography>
                                    <Typography variant="h4">
                                      {parseFloat(
                                        orderFromAPI[0].discount_value
                                      ).toFixed(decimalPlaces)}
                                    </Typography>
                                  </Stack>
                                )}

                                {orderFromAPI[0] !== undefined &&
                                  orderFromAPI[0].order_type_flag === "0" && ( // delivery (0)
                                    <Stack // delivery charges
                                      direction={"row"}
                                      spacing={0.25}
                                      sx={responsiveAlignmentEnd}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: "Roboto",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "12px",
                                          color: "#757575",
                                        }}
                                      >
                                        {orderFromAPI[0].currency}
                                      </Typography>
                                      <Typography variant="h4">
                                        {Number(
                                          orderFromAPI[0].delivery_charges
                                        ).toFixed(decimalPlaces)}
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  Number(orderFromAPI[0].tax_value) > 0 && (
                                    <Stack // tax
                                      direction={"row"}
                                      spacing={0.25}
                                      sx={responsiveAlignmentEnd}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: "Roboto",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "12px",
                                          color: "#757575",
                                        }}
                                      >
                                        {orderFromAPI[0].currency}
                                      </Typography>
                                      <Typography variant="h4">
                                        {parseFloat(
                                          orderFromAPI[0].tax_value
                                        ).toFixed(decimalPlaces)}
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  Number(orderFromAPI[0].tip) > 0 && (
                                    <Stack // tip
                                      direction={"row"}
                                      spacing={0.25}
                                      sx={responsiveAlignmentEnd}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: "Roboto",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "12px",
                                          color: "#757575",
                                        }}
                                      >
                                        {orderFromAPI[0].currency}
                                      </Typography>
                                      <Typography variant="h4">
                                        {parseFloat(
                                          orderFromAPI[0].tip
                                        ).toFixed(decimalPlaces)}
                                      </Typography>
                                    </Stack>
                                  )}

                                {orderFromAPI[0] !== undefined &&
                                  Number(orderFromAPI[0].service_charges) >
                                    0 && (
                                    <Stack // service charges
                                      direction={"row"}
                                      spacing={0.25}
                                      sx={responsiveAlignmentEnd}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: "Roboto",
                                          fontStyle: "normal",
                                          fontWeight: "400",
                                          fontSize: "12px",
                                          color: "#757575",
                                        }}
                                      >
                                        {orderFromAPI[0].currency}
                                      </Typography>
                                      <Typography variant="h4">
                                        {parseFloat(
                                          orderFromAPI[0].service_charges
                                        ).toFixed(decimalPlaces)}
                                      </Typography>
                                    </Stack>
                                  )}
                              </Stack>
                            </Stack>

                            <Divider
                              sx={{
                                m: "24px 0px",
                                border: " 1px solid rgba(0, 0, 0, 0.06)",
                              }}
                            />

                            <Stack
                              direction={"row"}
                              justifyContent={"space-between"}
                            >
                              <Stack direction={"column"}>
                                <Stack // total
                                  direction={"row"}
                                  sx={{
                                    ...responsiveAlignmentStart,
                                    mt: "0",
                                  }}
                                  width={
                                    selectedOrderContext.status === "Pending"
                                      ? "129px"
                                      : "105px"
                                  }
                                >
                                  <Typography variant="h4">Total</Typography>
                                </Stack>
                              </Stack>

                              <Stack direction={"column"}>
                                <Stack // total
                                  direction="row"
                                  spacing={0.25}
                                  sx={{
                                    justifyContent: "flex-end",
                                    textAlign: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: "Roboto",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "12px",
                                      color: "#757575",
                                    }}
                                  >
                                    {orderFromAPI[0] !== undefined &&
                                      orderFromAPI[0].currency}
                                  </Typography>
                                  <Typography variant="h4">
                                    {orderFromAPI[0] !== undefined &&
                                      parseFloat(
                                        orderFromAPI[0].grand_total
                                      ).toFixed(decimalPlaces)}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Stack>
                          </>
                        )}
                      </Grid>
                    </Box>
                  </MainCard>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={4.7}
                  lg={3.7}
                  sx={{ ml: { md: "19px" } }}
                >
                  {orderFromAPI.length === 0 ? (
                    <Box
                      sx={{
                        p: "0px 16px 24px 16px",
                        border: "1px solid #EEEEEE",
                        mb: "24px",
                      }}
                    >
                      <OrderTimelineSkeleton />
                    </Box>
                  ) : (
                    <OrderStatusAction // order  status component
                      preAuth={{
                        preauth:
                          orderFromAPI[0] !== undefined
                            ? orderFromAPI[0].pre_auth
                            : "",
                        trans_amount:
                          orderFromAPI[0] !== undefined
                            ? orderFromAPI[0].pre_auth_trans[0]?.trans_amount
                            : "",
                      }}
                      orderType={orderFromAPI[0].order_type_flag}
                      order_id={selectedOrder.order_id}
                      user_email={selectedOrder.user_email}
                      quickBookInvoice={orderFromAPI[0]?.invoice_id}
                    />
                  )}

                  {orderFromAPI.length === 0 ? (
                    <Box
                      sx={{
                        p: "24px 16px",
                        border: "1px solid #EEEEEE",
                      }}
                    >
                      <MapSectionSkeleton />
                    </Box>
                  ) : (
                    <>
                      {Number(orderFromAPI[0]?.user_latitude) !== 0 &&
                        Number(orderFromAPI[0]?.user_longitude) !== 0 && (
                          <MainCard // google map card
                            dividerSX={{ m: "0px 0px 18px 0px !important" }}
                            headerSX={{ p: "unset !important", mb: "24px" }}
                            contentSX={mapFrameContentStyles}
                            sx={mapFrameCardSXStyles}
                            title={
                              <Typography variant="h4">Geo Location</Typography>
                            }
                          >
                            <GoogleMapFrame
                              longitude={orderFromAPI[0].user_longitude}
                              latitude={orderFromAPI[0].user_latitude}
                              title={""}
                              width={"100%"}
                              height={"279px"}
                              style={{ border: "none", borderRadius: "8px" }}
                            />
                          </MainCard>
                        )}
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Paper>
      </Modal>

      <Modal // User Detail Modal
        open={customerDetailModal}
        onClose={toggleCustomerDetailModal}
      >
        <MainCard
          dividerSX={{ m: "0px 0px 33px 0px !important" }}
          headerSX={{ p: "unset !important", mb: "16px" }}
          contentSX={{
            "& .MuiCardContent-root": {
              p: "unset !important",
            },
            m: "unset",
            p: "unset !important",
          }}
          sx={actionModalSX}
          title={
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "190px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant={"h3"}>Customer Details</Typography>
                <Box>{customerDetailLoader && <Progress type="circle" />}</Box>
              </Box>

              <IconButton
                sx={{ p: "unset" }}
                onClick={toggleCustomerDetailModal}
              >
                <HighlightOffTwoTone
                  sx={{ color: "#D84315" }}
                  fontSize="large"
                />
              </IconButton>
            </Stack>
          }
        >
          <CardContent>
            <Stack sx={{ mb: "24px" }}>
              <TextField
                label="Address"
                value={customerAddress}
                onChange={handleAddressChange}
                error={fieldError.address === "" ? false : true}
                helperText={fieldError.address}
              />
            </Stack>
            <Stack sx={{ mb: "33px" }}>
              <TextField
                label="Mobile"
                value={customerMobileNo}
                onChange={handleMobileNoChange}
                error={fieldError.mobileNo === "" ? false : true}
                helperText={fieldError.mobileNo}
              />
            </Stack>

            <Stack direction="row" sx={{ justifyContent: "end" }}>
              <Button
                color={"secondary"}
                variant={"contained"}
                onClick={handleCustomerDetailUpdate}
                sx={{
                  p: "13px 44px",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Update
              </Button>
            </Stack>
          </CardContent>
        </MainCard>
      </Modal>

      {/* Pickup Modal */}
      <Modal open={pickupModal} onClose={togglePickupModal}>
        <MainCard
          dividerSX={{ m: "0px 0px 33px 0px !important" }}
          headerSX={{ p: "unset !important", mb: "16px" }}
          contentSX={{
            "& .MuiCardContent-root": {
              p: "unset !important",
            },
            m: "unset",
            p: "unset !important",
          }}
          sx={actionModalSX}
          title={
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "190px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant={"h3"}>Details</Typography>
                <Box>{customerDetailLoader && <Progress type="circle" />}</Box>
              </Box>

              <IconButton sx={{ p: "unset" }} onClick={togglePickupModal}>
                <HighlightOffTwoTone
                  sx={{ color: "#D84315" }}
                  fontSize="large"
                />
              </IconButton>
            </Stack>
          }
        >
          <CardContent>
            {orderFromAPI[0] !== undefined &&
              orderFromAPI[0].order_type_flag === "1" && (
                <>
                  <Stack sx={{ mb: "24px" }}>
                    <TextField
                      name="pickupTime"
                      type="datetime-local"
                      label="Pickup Time"
                      value={pickuptime}
                      disablePrevDates={true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={handlePickupChange}
                    />
                  </Stack>

                  <Stack sx={{ mb: "33px" }}>
                    <TextField
                      label="Comment"
                      name="comment"
                      value={pickupComment}
                      onChange={handleCommentChange}
                    />
                  </Stack>
                </>
              )}
            <Stack sx={{ mb: "24px" }}>
              <TextField
                name="staffNote"
                type="text"
                label="Staff Note"
                value={staffNote}
                InputLabelProps={{ shrink: true }}
                rows={3}
                multiline={true}
                onChange={handleStaffNoteChange}
                sx={textAreaStyles}
              />
            </Stack>

            <Stack direction="row" sx={{ justifyContent: "end" }}>
              <Button
                color={"secondary"}
                variant={"contained"}
                onClick={updateOrderTypeDetails}
                sx={{
                  p: "13px 44px",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Update
              </Button>
            </Stack>
          </CardContent>
        </MainCard>
      </Modal>

      {/* Delivery charges modal */}
      <Modal open={deliveryChargesModal} onClose={toggleDeliveryChargesModal}>
        <MainCard
          dividerSX={{ m: "0px 0px 33px 0px !important" }}
          headerSX={{
            p: "unset !important",
            mb: "16px",
          }}
          contentSX={{
            "& .MuiCardContent-root": {
              p: "unset !important",
            },
            m: "unset",
            p: "unset !important",
          }}
          sx={actionModalSX}
          title={
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "290px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant={"h3"}>Edit Delivery Charges</Typography>
                <Box>{customerDetailLoader && <Progress type="circle" />}</Box>
              </Box>

              <IconButton
                sx={{ p: "unset" }}
                onClick={toggleDeliveryChargesModal}
              >
                <HighlightOffTwoTone
                  sx={{ color: "#D84315" }}
                  fontSize="large"
                />
              </IconButton>
            </Stack>
          }
        >
          <CardContent>
            <Stack
              sx={{
                mb: "33px",
                alignItem: "center",
              }}
            >
              {selectedOrderContext.canada_post === "1" ? (
                <>
                  <Typography variant="h5">Select Canada Post</Typography>
                  <RadioButton
                    sx={{
                      display: "inline !important",
                    }}
                    options={deliveryChargesList}
                    onChange={canadaPostHandler}
                    value={canadaPostDeliveryCharges}
                  />
                </>
              ) : (
                <TextField
                  type="text"
                  label="Delivery Charges"
                  value={deliveryChargeField}
                  onChange={handleDeliveryChargesField}
                  error={fieldError.deliveryCharges === "" ? false : true}
                  helperText={fieldError.deliveryCharges}
                />
              )}
            </Stack>
            <Stack direction="row" sx={{ justifyContent: "end" }}>
              <Button
                color={"secondary"}
                variant={"contained"}
                onClick={handleDeliveryChargesUpdate}
                sx={{
                  p: "13px 44px",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Update
              </Button>
            </Stack>
          </CardContent>
        </MainCard>
      </Modal>

      {/* Discount Modal */}
      <Modal open={toggleDiscount} onClose={toggleDiscountModal}>
        <MainCard
          dividerSX={{ m: "0px 0px 33px 0px !important" }}
          headerSX={{
            p: "unset !important",
            mb: "16px",
          }}
          contentSX={{
            "& .MuiCardContent-root": {
              p: "unset !important",
            },
            m: "unset",
            p: "unset !important",
          }}
          sx={actionModalSX}
          title={
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "290px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant={"h3"}>Edit Discount</Typography>
              </Box>

              <IconButton sx={{ p: "unset" }} onClick={toggleDiscountModal}>
                <HighlightOffTwoTone
                  sx={{ color: "#D84315" }}
                  fontSize="large"
                />
              </IconButton>
            </Stack>
          }
        >
          <CardContent>
            <Stack
              sx={{
                mb: "33px",
                alignItem: "center",
              }}
            >
              <TextField
                type="text"
                label="Discount"
                value={discountField}
                onChange={handleDiscountField}
              />
            </Stack>
            <Stack direction="row" sx={{ justifyContent: "end" }}>
              <Button
                color={"secondary"}
                variant={"contained"}
                onClick={handleDiscountUpdate}
                sx={{
                  p: "13px 44px",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Update
              </Button>
            </Stack>
          </CardContent>
        </MainCard>
      </Modal>

      <Modal
        open={packingSlip}
        onClose={printPreviewModal}
        sx={{ width: "99vw", Height: "99vh" }}
      >
        <MainCard
          title={
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "190px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant={"h2"}>Print Preview</Typography>
              </Box>

              <IconButton sx={{ p: "unset" }} onClick={printPreviewModal}>
                <HighlightOffTwoTone
                  sx={{ color: "#D84315" }}
                  fontSize="large"
                />
              </IconButton>
            </Stack>
          }
        >
          <PDFViewer style={{ width: "95vw", height: "95vh" }}>
            <PackingSlip
              packingSlipData={orderFromAPI}
              pdfType={"pdf"}
              totalWeight={totalWeight}
              weightUnit={weightUnit}
            />
          </PDFViewer>
        </MainCard>
      </Modal>

      <Modal
        open={togglePrinterModal}
        onClose={() => setTogglePrinterModal(false)}
      >
        <MainCard
          dividerSX={{ m: "0px 0px 33px 0px !important" }}
          headerSX={{
            p: "unset !important",
            mb: "16px",
          }}
          contentSX={{
            "& .MuiCardContent-root": {
              p: "unset !important",
            },
            m: "unset",
            p: "unset !important",
          }}
          sx={actionModalSX}
          title={
            <Stack
              direction="row"
              sx={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "290px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant={"h3"}>Select Printer Type</Typography>
              </Box>

              <IconButton
                sx={{ p: "unset" }}
                onClick={() => setTogglePrinterModal(false)}
              >
                <HighlightOffTwoTone
                  sx={{ color: "#D84315" }}
                  fontSize="large"
                />
              </IconButton>
            </Stack>
          }
        >
          <CardContent>
            <Stack sx={{ mb: "33px", alignItem: "center" }}>
              <RadioButton
                sx={{ ".MuiFormGroup-root": { flexDirection: "row" } }}
                options={printerOptions}
                onChange={handlePrinterSelection}
                defaultValue={selectedPrinterRef.current}
              />
            </Stack>
            <Stack direction="row" sx={{ justifyContent: "end" }}>
              <Button
                color={"secondary"}
                variant={"contained"}
                onClick={savePrinterSelection}
                sx={modalButtonStyles}
              >
                Confirm
              </Button>
            </Stack>
          </CardContent>
        </MainCard>
      </Modal>

      <ThermalReceiptPrint orderData={orderFromAPI?.[0]} />
    </>
  );
};

export default OrderDetail;
